import {actionIds, BaseAction} from "../common";

const reconnectAbortAction: () =>
    BaseAction = () => ({
    type: actionIds.RECONNECT_ABORT,
    payload: {},
});

export default reconnectAbortAction;
